import { useEffect } from 'react';

export default function Loader(): JSX.Element | null {
    useEffect(() => {
        const footerElem: HTMLElement | null = document.getElementById('footer');

        if (!footerElem) {
            return;
        }

        footerElem.style.position = 'absolute';
        footerElem.style.bottom = '0';

        return (): void => {
            footerElem.style.position = 'unset';
            footerElem.style.bottom = 'unset';
        };
    }, []);

    return (
        <div className="loader-container">
            <span className="loader"></span>
        </div>
    );
}